import axios,  { AxiosResponse } from 'axios';
import { responseAPI } from './IResponseAPI'

const storeMethod: string = 'store';
const validFolioMethod: string = 'isValidFolio'
const urlApi: any = process.env.NODE_ENV === "production" ? process.env.REACT_APP_URL_AUTHENTICATE : process.env.REACT_APP_URL_AUTHENTICATE_ENV;

const store = async(data: any) =>{
    const response = await axios.post(`${urlApi}${storeMethod}`,data).then((response:AxiosResponse<any>)=> {

        const resp: responseAPI = {
            success: response.status === 200 ? true : false,
            data: response.status === 200 ? response.data.data : response.data.errors[0],
            message: response.status === 200 ? "Ok" : 'Bad Request'
        }

        return resp;

    }).catch(error =>{

        const resp: responseAPI = {
            success: false,
            data: error.response.data.errors,
            message: 'Bad Request'
        }

        return resp;
    });

    return response
}

const validFolio = async(data: any) =>{
    const response = await axios.post(`${urlApi}${validFolioMethod}`,data).then((response:AxiosResponse<any>)=> {

        const resp: responseAPI = {
            success: response.status === 200 ? true : false,
            data: response.status === 200 ? response.data.data : response.data.errors,
            message: response.status === 200 ? "Ok" : "Bad Request"
        }

        return resp;

    }).catch(error =>{

        const resp: responseAPI = {
            success: false,
            data: error.response.data.errors,
            message: 'Bad Request'
        }

        return resp;
    });

    return response
}

const functions = {
    store, validFolio
}


export default functions;